import { render, staticRenderFns } from "./buttonsList.vue?vue&type=template&id=2eec12fa&scoped=true"
import script from "./buttonsList.vue?vue&type=script&lang=js"
export * from "./buttonsList.vue?vue&type=script&lang=js"
import style0 from "./buttonsList.vue?vue&type=style&index=0&id=2eec12fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eec12fa",
  null
  
)

export default component.exports